import { useEffect, useState } from 'react'
import { Button, Modal } from '../../design-system/primitives/index.js'
import BottomSheet from '../../design-system/patterns/BottomSheet.jsx'
import Register from '../Register.jsx'
import { getKeepInventory, getOnboardingProfileNames } from '../../utils/guestKitchen.js'
import { authenticatedFetch } from '../../utils/auth.js'

function Inventory({ kitchen, summary }) {
  const inventory = { ...getKeepInventory(kitchen), ...summary }
  const profileNames = inventory.profileNames?.length
    ? inventory.profileNames
    : getOnboardingProfileNames(kitchen?.preferences)
  return (
    <ul className="keep-kitchen__inventory">
      <li><span>Pantry</span><strong>{inventory.pantryCount} items</strong></li>
      <li><span>Recipes</span><strong>{inventory.recipeCount}</strong></li>
      <li><span>This week</span><strong>{inventory.plannedDinners} dinners</strong></li>
      {inventory.shoppingItemCount != null ? <li><span>Shopping list</span><strong>{inventory.shoppingItemCount} items</strong></li> : null}
      <li>
        <span>Household</span>
        <strong>{profileNames.length ? profileNames.join(', ') : 'Not added'}</strong>
      </li>
    </ul>
  )
}

function KeepContent({ kitchen, summary, onRegistered, onLoginInstead, merging }) {
  return (
    <div className="keep-kitchen__layout">
      <section className="keep-kitchen__pitch">
        <div className="page-intro-eyebrow-slot">
          <p className="guest-home__eyebrow">KEEP WHAT YOU BUILT</p>
        </div>
        <h2>Save your kitchen</h2>
        <p>Keep your recipes, pantry, plan, and list.</p>
        <Inventory kitchen={kitchen} summary={summary} />
        <p className="keep-kitchen__ai-note">
          <i className="fas fa-sparkles" aria-hidden="true" />
          The Captain helps plan your week from this kitchen.
        </p>
      </section>
      <section className="keep-kitchen__form">
        {merging ? (
          <div className="keep-kitchen__merging" role="status" aria-live="polite">
            <i className="fas fa-spinner fa-spin" aria-hidden="true" />
            <strong>Saving your kitchen…</strong>
            <span>This only takes a moment.</span>
          </div>
        ) : null}
        <div className="page-intro-eyebrow-slot" aria-hidden="true" />
        <h2>Create your account</h2>
        <Register
          embedded
          showTitle={false}
          kitchenFraming
          routeToPantry={false}
          submitLabel="Save my kitchen"
          onRegisterSuccess={onRegistered}
          onSwitchToLogin={onLoginInstead}
        />
      </section>
    </div>
  )
}

export default function KeepKitchenDialog({
  open,
  mobile = false,
  kitchen,
  onRegistered,
  onLoginInstead,
  onNotNow,
  merging = false,
}) {
  const [summary, setSummary] = useState(null)

  useEffect(() => {
    if (!open) return undefined
    let active = true
    authenticatedFetch('/guest/summary')
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        if (active && data) setSummary(data)
      })
      .catch(() => {})
    return () => {
      active = false
    }
  }, [open])

  if (mobile) {
    return (
      <BottomSheet open={open} onClose={merging ? () => {} : onNotNow} className="keep-kitchen__sheet" aria-label="Save your kitchen">
        <KeepContent
          kitchen={kitchen}
          summary={summary}
          onRegistered={onRegistered}
          onLoginInstead={onLoginInstead}
          merging={merging}
        />
      </BottomSheet>
    )
  }
  return (
    <Modal
      open={open}
      onClose={merging ? () => {} : onNotNow}
      titleId="keep-kitchen-title"
      contentClassName="keep-kitchen__modal"
    >
      <Button
        className="keep-kitchen__close"
        onClick={onNotNow}
        disabled={merging}
        aria-label="Close"
      >
        ×
      </Button>
      <KeepContent
        kitchen={kitchen}
        summary={summary}
        onRegistered={onRegistered}
        onLoginInstead={onLoginInstead}
        merging={merging}
      />
    </Modal>
  )
}
